import { action, atom } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'

import {
  fetchReferralLeaderboardRequestAction,
  fetchTradingLeaderboardRequestAction,
} from './leaderboard-requests'

import type { LeaderboardEntry } from '../model'
import type { Error } from '@root/shared'

export const tradingLeaderboardStateAtom = atom(
  AsyncStateN.notInitiated<
    Error.UnknownError,
    Array<LeaderboardEntry.TradeLeaderboardEntry>
  >(),
  'tradingLeaderboardStateAtom',
)

export const loadTradingLeaderboardAction = action(async (ctx) => {
  const state = ctx.get(tradingLeaderboardStateAtom)
  if (AsyncStateN.isSuccess(state) || AsyncStateN.isLoading(state)) {
    return
  }

  tradingLeaderboardStateAtom(ctx, AsyncStateN.loading())

  const result = await ctx.schedule(() =>
    fetchTradingLeaderboardRequestAction(ctx, { limit: 30, offset: 0 }),
  )

  tradingLeaderboardStateAtom(ctx, AsyncStateN.fromResult(result))
}, 'loadTradingLeaderboardAction')

export const referralLeaderboardStateAtom = atom(
  AsyncStateN.notInitiated<
    Error.UnknownError,
    Array<LeaderboardEntry.ReferralLeaderboardEntry>
  >(),
  'referralLeaderboardStateAtom',
)

export const loadReferralLeaderboardAction = action(async (ctx) => {
  const state = ctx.get(referralLeaderboardStateAtom)

  if (AsyncStateN.isSuccess(state) || AsyncStateN.isLoading(state)) {
    return
  }

  referralLeaderboardStateAtom(ctx, AsyncStateN.loading())

  const result = await ctx.schedule(() =>
    fetchReferralLeaderboardRequestAction(ctx, {
      limit: 30,
      offset: 0,
    }),
  )

  referralLeaderboardStateAtom(ctx, AsyncStateN.fromResult(result))
}, 'loadReferralLeaderboardAction')

export * from './leaderboard-requests'
